"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onFirstDataRendered = exports.gridOptions = exports.defaultColDef = void 0;
var defaultColDef = {
  sortable: true,
  filter: false,
  resizable: true,
  wrapText: true,
  suppressMovable: true
};
exports.defaultColDef = defaultColDef;
var gridOptions = {
  defaultColDef: defaultColDef,
  pagination: true,
  paginationPageSize: 10,
  suppressHorizontalScroll: true,
  overlayLoadingTemplate: '<sdf-busy-indicator size=\'xl\'></sdf-busy-indicator>'
};
exports.gridOptions = gridOptions;
var onFirstDataRendered = function onFirstDataRendered(params) {
  if (params.api) {
    var gridApi = params.api;
    gridApi.sizeColumnsToFit();
  }
};
exports.onFirstDataRendered = onFirstDataRendered;